/*
 * @Author: your name
 * @Date: 2020-07-08 15:38:11
 * @LastEditTime: 2020-08-24 10:26:25
 * @LastEditors: Zhanglei
 * @Description: In User Settings Edit
 * @FilePath: /desktop/src/store/modules/languages.js
 */
import {
  getLanguagesFileApi,
  getLanguagesListApi,
  getI18nDataApi,
  getChangeDataApi,
  deleteDataApi,
  postDataApi
} from "@/service/languageService";
import { setStore } from '@/utils/store'

const languages = {
  state: {
    // 设备语言 默认中文
    currentLang: {
      name: "Engilsh",
      value: "en"
    },
    // 支持下面这些语言
    langArr: [
      {
        name: "中文",
        value: "zh-CN"
      },
      {
        name: "Engilsh",
        value: "en"
      }
    ],
    _lang: {
      name: "中文",
      value: "zh-CN"
    },
    massage: {
      en: [],
      "zh-CN": []
    }
  },
  mutations: {
    changeLangVux(state, payload) {
      console.log(payload);
      state.currentLang = payload;
    }
  },
  getters: {
    // 获取支持语言列表
    getLangsList(state) {
      this.getLanguagesList()
        .then(res => {
          console.log("支持语言列表x", res);
          state.langArr = res.languages;
        })
        .catch(e => {
          console.log("支持语言列表x", e);
        });
    },
    // 返回当前设备的语言
    getCurrentLanguage(state) {
      let _userAgent = navigator.language || window.navigator["userLanguage"];
      state.currentLang.value = _userAgent;
      for (let i = 0; i < state.langArr.length; i++) {
        if (state.langArr[i].value === _userAgent) {
          state.currentLang.name = state.langArr[i].name;
        }
      }
      setStore({name: 'lang', content: state.currentLang, type: true})
      return state.currentLang;
    }
  },
  actions: {
    changeL(state, lang) {
      this.state._lang = lang;
      console.log("111111111111", lang);
      setStore({name: 'lang', content: lang, type: true})
      state.commit("changeLangVux", lang);
    },
    getLanguagesFile(store, lang) {
      return new Promise((resolve, reject) => {
        getLanguagesFileApi(lang)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getLanguagesList(store) {
      return new Promise((resolve, reject) => {
        getLanguagesListApi()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getI18nData(store, idInfo) {
      return new Promise((resolve, reject) => {
        getI18nDataApi(idInfo)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getChangeI18nData(store, data) {
      return new Promise((resolve, reject) => {
        getChangeDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteI18nData(store, id) {
      return new Promise((resolve, reject) => {
        deleteDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    postI18nData(store, data) {
      return new Promise((resolve, reject) => {
        postDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default languages;



// WEBPACK FOOTER //
// ./src/store/modules/languages.js